const VerticalLine = () => {
  return <div className="vertical-line" />;
};

export default VerticalLine;
